import(/* webpackMode: "eager" */ "/var/lib/jenkins/workspace/Umbrella_Umbrella_Frontend_prod/src/app/error.tsx");
